
// 成本评价柱状图
export const options_2 = {
    title: {
        text: "成本评价(万元)",
    },
    tooltip: {
        trigger: 'item',
        formatter: '{b} <br/>{a}: {c}'
    },
    legend: {
        data: ["成本(万元)"],
    },
    xAxis: {
    },
    yAxis: {
        min: 0,
        max: 900,
        splitNumber: 3,
    },
    series: [
        {
            name: "成本(万元)",
            type: "bar",
            itemStyle: {
                color: '#0c64eb'
            }
        },
    ],

};
//创收(万元)
export const opt_income = {
    title: {
        text: "创收评价(万元)",
    },
    tooltip: {
        trigger: 'item',
        formatter: '{b}：{c}万元'
    },
    graphic: {
        elements: [
            {
                type: 'text',
                left: 'center',
                top: '48%',
                style: {
                    text: '100000',
                    textAlign: 'center',
                    fill: '#000',
                    width: 30,
                    height: 30,
                    fontSize: 25,
                }
            }
        ]
    },
    legend: {
        data: []
    },
    series: [
        {   
            name: '访问来源',
            type: 'pie',
            radius: ['40%', '55%'],
            avoidLabelOverlap: false,
            label: {
                formatter: '{b}：\n ',
                alignTo:'labelLine',
                formatter: [
                    '{a|{b}}',
                    '{b|{d}%}'
                ].join(''),
                rich: {
                    a: {
                        fontSize:10,
                        textAlign:'center'
                    },
                    b: {
                        fontSize:10,
                        textAlign:'center'
                    }
                }
            },
            emphasis: {
                label: {
                    show: true,
                }
            },
            labelLine: {
                show: true,
                length:5,
                length2:5
            },
        }
    ]
};
//临床满意度
export const opt_clinical_satisfaction = {
    title:{
        text:'临床满意度',
        left: "center",
        textStyle:{
            fontSize:14,
            fontWeight:'normal'
        }
    },
    graphic: {
        elements: [
            {
                type: 'text',
                left: 'center',
                top: '65%',
                style: {
                    text: '优',//
                    fill: 'green',//
                    textAlign: 'center',
                    width: 30,
                    height: 30,
                }
            },
            {
                type: 'text',
                left: 'center',
                top: '72%',
                style: {
                    text: '50%',//
                    fill: 'green',//
                    textAlign: 'center',
                    width: 30,
                    height: 30,
                }
            }
        ]
    },
    series: [
        {
            type: 'gauge',
            detail: { show: false, formatter: '{value}%' },
            min:0,
            max:100,
            splitNumber:100,
            data: [{ value: 50, name: '' }],//
            axisTick: {
                show: false
            },
            axisLabel: {
                show: true,
                distance:0,
                formatter:null,
            },
            axisLine: {
                lineStyle: {
                   
                }
            },
            splitLine: {
                show: false
            },
        }
    ]
}
//患者满意度
export const opt_patients_satisfaction = {
    title:{
        left: "center",
        text:'患者满意度',    
        textStyle:{
            fontSize:14,
            fontWeight:'normal'
        }
    },
    graphic: {
        elements: [
            {
                type: 'text',
                left: 'center',
                top: '65%',
                style: {
                    text: '优',
                    fill: 'green',
                    textAlign: 'center',
                    width: 30,
                    height: 30,
                }
            },
            {
                type: 'text',
                left: 'center',
                top: '72%',
                style: {
                    text: '50%',
                    fill: '#000',
                    textAlign: 'center',
                    width: 30,
                    height: 30,
                }
            }
        ]
    },
    series: [
        {
            type: 'gauge',
            detail: { show: false, formatter: '{value}%' },
            min:0,
            max:100,
            splitNumber:100,
            data: [{ value: 50, name: '' }], // 
            startAngle:225,
            endAngle:-45,
            axisTick: {
                show: false
            },
            axisLabel: {
                show: true,
                distance:0,
                formatter: null
            },
            axisLine: {
                lineStyle: {} //配置项
            },
            splitLine: {
                show: false
            },
        }
    ]
}